import script from "./DynamicCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicCover.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicCover.vue?vue&type=style&index=0&id=5ae583fa&lang=scss&setup=true"

const __exports__ = script;

export default __exports__